import {PlayerColor} from '@colonist/game-states'
import {type ImageURL} from '@colonist/types'
import ShipMoveRed from '@static/images/ship_move_red.svg'
import ShipMoveBlue from '@static/images/ship_move_blue.svg'
import ShipMoveOrange from '@static/images/ship_move_orange.svg'
import ShipMoveGreen from '@static/images/ship_move_green.svg'
import ShipMoveBlack from '@static/images/ship_move_black.svg'
import ShipMoveBronze from '@static/images/ship_move_bronze.svg'
import ShipMoveSilver from '@static/images/ship_move_silver.svg'
import ShipMoveGold from '@static/images/ship_move_gold.svg'
import ShipMoveWhite from '@static/images/ship_move_white.svg'
import ShipMovePurple from '@static/images/ship_move_purple.svg'
import ShipMoveMysticBlue from '@static/images/ship_move_mysticblue.svg'
import ShipMovePink from '@static/images/ship_move_pink.svg'

export const SHIP_MOVE_IMAGE_PATH: Record<PlayerColor, ImageURL> = {
    [PlayerColor.None]: '' as ImageURL,
    [PlayerColor.Red]: ShipMoveRed,
    [PlayerColor.Blue]: ShipMoveBlue,
    [PlayerColor.Orange]: ShipMoveOrange,
    [PlayerColor.Green]: ShipMoveGreen,
    [PlayerColor.Black]: ShipMoveBlack,
    [PlayerColor.Bronze]: ShipMoveBronze,
    [PlayerColor.Silver]: ShipMoveSilver,
    [PlayerColor.Gold]: ShipMoveGold,
    [PlayerColor.White]: ShipMoveWhite,
    [PlayerColor.Purple]: ShipMovePurple,
    [PlayerColor.MysticBlue]: ShipMoveMysticBlue,
    [PlayerColor.Pink]: ShipMovePink,
}
